var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders, NUMBER_ASSIGN_TIMEOUT_MS } from "../utils/apiUtils";
import { escapeCql } from "./agencyPrefixesService";
import { API_PATHS } from "../types/apiPaths";
import { dateRangeCriteria } from "../utils/dateRangeFilters";
import { DEFAULT_MAX_ITEMS, fetchAllPages, } from "../utils/fetchAllPages";
export var fetchProductNumbers = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var publisher, publisherPrefix, productNumber, blocked, offset, limit, queryParts, normalizedNumber, baseQuery, searchParams, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                publisher = filters.publisher, publisherPrefix = filters.publisherPrefix, productNumber = filters.productNumber, blocked = filters.blocked, offset = filters.offset, limit = filters.limit;
                queryParts = [];
                if (publisher)
                    queryParts.push("publisher.sourceId==\"".concat(publisher, "\""));
                if (publisherPrefix)
                    queryParts.push("publisherPrefix.id==\"".concat(publisherPrefix, "\""));
                if (productNumber) {
                    normalizedNumber = productNumber.replace(/-/g, "");
                    queryParts.push("value==\"*".concat(escapeCql(normalizedNumber), "*\""));
                }
                if (blocked !== undefined)
                    queryParts.push("blocked==\"".concat(blocked, "\""));
                baseQuery = queryParts.length > 0 ? queryParts.join(" and ") : "cql.allRecords=1";
                searchParams = new URLSearchParams();
                searchParams.set("query", "".concat(baseQuery, " sortBy value id"));
                searchParams.set("offset", String(offset));
                searchParams.set("limit", String(limit));
                return [4 /*yield*/, kyInstance.get(API_PATHS.PRODUCT_NUMBERS, {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_1 = _a.sent();
                console.error("Fetch error:", error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchProductNumbersByTitleId = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("product-numbers/by-title/".concat(encodeURIComponent(titleId)), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
/**
 * Loads every product number matching a CQL query, page by page within the
 * backend list limit.
 */
var fetchAllProductNumbers = function (kyInstance, query, signal) {
    return fetchAllPages(function (offset, limit) { return __awaiter(void 0, void 0, void 0, function () {
        var searchParams, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchParams = new URLSearchParams();
                    searchParams.set("query", query);
                    searchParams.set("offset", String(offset));
                    searchParams.set("limit", String(limit));
                    return [4 /*yield*/, kyInstance.get(API_PATHS.PRODUCT_NUMBERS, {
                            searchParams: searchParams,
                            headers: getHeaders(),
                            signal: signal,
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
            }
        });
    }); });
};
export var fetchProductNumbersByProductId = function (kyInstance, productId) { return __awaiter(void 0, void 0, void 0, function () {
    var items, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchAllProductNumbers(kyInstance, "product.id==\"".concat(escapeCql(productId), "\" sortBy value id"))];
            case 1:
                items = _a.sent();
                return [2 /*return*/, { items: items, totalRecords: items.length }];
            case 2:
                error_2 = _a.sent();
                console.error("Fetch product numbers by product ID error:", error_2);
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
// Keeps the CQL query (and so the request URL) of one batch reasonably short.
var PRODUCT_IDS_PER_REQUEST = 50;
/**
 * Loads the product numbers of several products, batched into a few CQL
 * requests instead of one request per product, grouped by product id.
 * A product without any number has no entry in the result.
 * Aborting the signal cancels every batch still in flight.
 */
export var fetchProductNumbersByProductIds = function (kyInstance, productIds, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var uniqueIds, batches, i, responses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                uniqueIds = Array.from(new Set(productIds.filter(Boolean)));
                batches = [];
                for (i = 0; i < uniqueIds.length; i += PRODUCT_IDS_PER_REQUEST) {
                    batches.push(uniqueIds.slice(i, i + PRODUCT_IDS_PER_REQUEST));
                }
                return [4 /*yield*/, Promise.all(batches.map(function (batch) { return __awaiter(void 0, void 0, void 0, function () {
                        var idsQuery;
                        return __generator(this, function (_a) {
                            idsQuery = batch
                                .map(function (id) { return "product.id==\"".concat(escapeCql(id), "\""); })
                                .join(" or ");
                            return [2 /*return*/, fetchAllProductNumbers(kyInstance, "(".concat(idsQuery, ") sortBy value id"), signal)];
                        });
                    }); }))];
            case 1:
                responses = _a.sent();
                return [2 /*return*/, responses
                        .flat()
                        .reduce(function (byProduct, productNumber) {
                        var _a;
                        var productId = (_a = productNumber.product) === null || _a === void 0 ? void 0 : _a.id;
                        if (productId) {
                            byProduct[productId] = __spreadArray(__spreadArray([], (byProduct[productId] || []), true), [productNumber], false);
                        }
                        return byProduct;
                    }, {})];
        }
    });
}); };
export var searchProductNumbers = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, filters) {
        var publisherId, publisherPrefixId, value, blocked, _a, offset, _b, limit, sortBy, searchParams_1, url, response, error_3;
        if (filters === void 0) { filters = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    publisherId = filters.publisherId, publisherPrefixId = filters.publisherPrefixId, value = filters.value, blocked = filters.blocked, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? 100 : _b, sortBy = filters.sortBy;
                    searchParams_1 = new URLSearchParams();
                    searchParams_1.set("offset", offset.toString());
                    searchParams_1.set("limit", limit.toString());
                    if (publisherId) {
                        searchParams_1.set("publisherId", publisherId);
                    }
                    if (publisherPrefixId) {
                        searchParams_1.set("publisherPrefixId", publisherPrefixId);
                    }
                    if (value) {
                        searchParams_1.set("value", value);
                    }
                    if (blocked !== undefined) {
                        searchParams_1.set("blocked", blocked.toString());
                    }
                    Object.entries(dateRangeCriteria(filters)).forEach(function (_a) {
                        var key = _a[0], date = _a[1];
                        return searchParams_1.set(key, date);
                    });
                    searchParams_1.set("query", "cql.allRecords=1 sortBy value");
                    // No sortBy: the server orders by product number ascending.
                    sortBy === null || sortBy === void 0 ? void 0 : sortBy.forEach(function (field) { return searchParams_1.append("sortBy", field); });
                    url = "".concat(API_PATHS.PRODUCT_NUMBERS_SEARCH, "?").concat(searchParams_1.toString());
                    return [4 /*yield*/, kyInstance.get(url, {
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Search product numbers error: ".concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
                case 2:
                    error_3 = _c.sent();
                    // Rethrow: the list must show a load error, not an empty registry ("Nalezeno 0 záznamů").
                    console.error("Search product numbers error:", error_3);
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var fetchProductNumberById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("".concat(API_PATHS.PRODUCT_NUMBERS, "/").concat(encodeURIComponent(id)), {
                    headers: getHeaders(),
                })];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error("Fetch product number by id failed: ".concat(res.status, " ").concat(res.statusText));
                }
                return [2 /*return*/, res.json()];
        }
    });
}); };
/**
 * Loads the publisher prefixes matching the filters, page by page within the
 * backend list limit, up to `limit` records (default: the whole — bounded — set,
 * e.g. the prefixes of one publisher).
 */
export var fetchPublisherPrefixes = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var publisherId, query, _a, limit, queryParts, baseQuery, sortedQuery_1, items, error_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                publisherId = filters.publisherId, query = filters.query, _a = filters.limit, limit = _a === void 0 ? DEFAULT_MAX_ITEMS : _a;
                queryParts = [];
                if (query) {
                    queryParts.push(query);
                }
                if (publisherId) {
                    queryParts.push("publisher.id==\"".concat(escapeCql(publisherId), "\""));
                }
                baseQuery = queryParts.length > 0 ? queryParts.join(" and ") : "cql.allRecords=1";
                sortedQuery_1 = /\bsortBy\b/.test(baseQuery)
                    ? baseQuery
                    : "".concat(baseQuery, " sortBy value id");
                return [4 /*yield*/, fetchAllPages(function (offset, pageLimit) { return __awaiter(void 0, void 0, void 0, function () {
                        var searchParams, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    searchParams = new URLSearchParams();
                                    searchParams.set("query", sortedQuery_1);
                                    searchParams.set("offset", String(offset));
                                    searchParams.set("limit", String(pageLimit));
                                    return [4 /*yield*/, kyInstance.get(API_PATHS.PUBLISHER_PREFIXES, {
                                            searchParams: searchParams,
                                            headers: getHeaders(),
                                        })];
                                case 1:
                                    response = _a.sent();
                                    return [4 /*yield*/, response.json()];
                                case 2: return [2 /*return*/, (_a.sent())];
                            }
                        });
                    }); }, { maxItems: limit })];
            case 1:
                items = _b.sent();
                return [2 /*return*/, { items: items, totalRecords: items.length }];
            case 2:
                error_4 = _b.sent();
                console.error("Fetch publisher prefixes error:", error_4);
                throw error_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var previewProductNumberAssignment = function (kyInstance, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.PRODUCT_NUMBERS_ASSIGN, "/preview"), {
                        json: data,
                        headers: getHeaders(),
                        // Preview can create a new publisher prefix + generate its number block.
                        timeout: NUMBER_ASSIGN_TIMEOUT_MS,
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to preview product number assignment: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [4 /*yield*/, response.json()];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                error_5 = _a.sent();
                console.error("Error previewing product number assignment:", error_5);
                throw error_5;
            case 6: return [2 /*return*/];
        }
    });
}); };
/**
 * Checks — before a product exists — whether an ISBN/ISMN can be assigned for a
 * title's publisher, and if not, why. Used to warn the user up front.
 *
 * The ONIX primary content type of the product about to be created decides the
 * registration agency (musical notation = ISMN, anything else = ISBN), so it must
 * be passed along for the offered prefixes to belong to the right agency.
 */
export var checkAssignFeasibility = function (kyInstance, titleId, primaryContentType) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("".concat(API_PATHS.PRODUCT_NUMBERS_ASSIGN, "/feasibility/").concat(encodeURIComponent(titleId)), {
                    headers: getHeaders(),
                    searchParams: primaryContentType ? { primaryContentType: primaryContentType } : undefined,
                })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to check assignment feasibility: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
export var getProductNumberAssignmentByProductId = function (kyInstance, productId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, kyInstance.get("".concat(API_PATHS.PRODUCT_NUMBERS_ASSIGN, "/").concat(encodeURIComponent(productId), "/by-product-id"), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to get product number assignment: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [4 /*yield*/, response.json()];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                error_6 = _a.sent();
                console.error("Error getting product number assignment by product ID:", error_6);
                throw error_6;
            case 6: return [2 /*return*/];
        }
    });
}); };
export var assignProductNumber = function (kyInstance, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.PRODUCT_NUMBERS_ASSIGN, {
                        json: data,
                        headers: getHeaders(),
                        // May create a new publisher prefix + generate its number block.
                        timeout: NUMBER_ASSIGN_TIMEOUT_MS,
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to assign product number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [4 /*yield*/, response.json()];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                error_7 = _a.sent();
                console.error("Error assigning product number:", error_7);
                throw error_7;
            case 6: return [2 /*return*/];
        }
    });
}); };
/**
 * Releases a product number that was reserved (selected) during an assignment
 * preview but never actually assigned — e.g. because the user closed the assign
 * modal without confirming. Without this, the reserved number stays
 * {@code selected = true} and is skipped by the "next available number" lookup,
 * leaving gaps in the assigned sequence.
 */
export var deselectProductNumber = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.PRODUCT_NUMBERS, "/").concat(encodeURIComponent(id), "/deselect"), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to deselect product number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [3 /*break*/, 5];
            case 4:
                error_8 = _a.sent();
                console.error("Error deselecting product number:", error_8);
                throw error_8;
            case 5: return [2 /*return*/];
        }
    });
}); };
export var createProductNumber = function (kyInstance, productNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.PRODUCT_NUMBERS, {
                        json: productNumber,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to create product number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [4 /*yield*/, response.json()];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                error_9 = _a.sent();
                console.error("Error creating product number:", error_9);
                throw error_9;
            case 6: return [2 /*return*/];
        }
    });
}); };
export var updateProductNumber = function (kyInstance, id, productNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, kyInstance.put("".concat(API_PATHS.PRODUCT_NUMBERS, "/").concat(encodeURIComponent(id)), {
                        json: productNumber,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to update product number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [4 /*yield*/, response.json()];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                error_10 = _a.sent();
                console.error("Error updating product number:", error_10);
                throw error_10;
            case 6: return [2 /*return*/];
        }
    });
}); };
export var blockProductNumber = function (kyInstance, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, kyInstance.put("".concat(API_PATHS.PRODUCT_NUMBERS, "/").concat(encodeURIComponent(id), "/block"), {
                        json: data,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to block product number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [3 /*break*/, 5];
            case 4:
                error_11 = _a.sent();
                console.error("Error blocking product number:", error_11);
                throw error_11;
            case 5: return [2 /*return*/];
        }
    });
}); };
export var unblockProductNumber = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, kyInstance.put("".concat(API_PATHS.PRODUCT_NUMBERS, "/").concat(encodeURIComponent(id), "/unblock"), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to unblock product number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [3 /*break*/, 5];
            case 4:
                error_12 = _a.sent();
                console.error("Error unblocking product number:", error_12);
                throw error_12;
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * Legalizes an already blocked product number by linking an existing title
 * (a product without a number) to it. On success the number is unblocked and
 * becomes assigned. Allowed only for an agency worker and only for numbers
 * blocked as PRESUMED_PUBLISHED or USED_BEFORE_REGISTRY (enforced server-side).
 */
export var assignTitleToBlockedProductNumber = function (kyInstance, productNumberId, productId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("".concat(API_PATHS.PRODUCT_NUMBERS, "/").concat(encodeURIComponent(productNumberId), "/assign-title"), {
                    json: { productId: productId },
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to assign title to blocked product number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
export var blockProductNumberRange = function (kyInstance, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, kyInstance.put("".concat(API_PATHS.PRODUCT_NUMBERS, "/block-range"), {
                        json: data,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to block product number range: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
            case 4:
                error_13 = _a.sent();
                console.error("Error blocking product number range:", error_13);
                throw error_13;
            case 5: return [2 /*return*/];
        }
    });
}); };
